import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/**
 * @description - use in combination with wb-input, wb-select, wb-toggle, wb-checkbox, wb-radio-button
 * @slot - Text placed within the element (required)
 */
@Component({
  tag: 'wb-control-hint',
  styleUrl: 'control-hint.scss',
  shadow: true,
})
export class ControlHintComponent implements ComponentInterface {
  @Element()
  el!: HTMLElement;

  /** @internal the color scheme */
  @Prop({ reflect: true })
  public theme?: WorkbenchTheme;

  private TagNames = transformTagNames(this, 'wb-control-hint', ['wb-text']);

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-control-hint" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <WbText size="s" static>
          <slot />
        </WbText>
      </Host>
    );
  }
}
